var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M5.75 2.01801H10.25C10.3875 2.01801 10.5 2.13051 10.5 2.26801V3.51801H5.5V2.26801C5.5 2.13051 5.6125 2.01801 5.75 2.01801ZM4 2.26801V3.51801H2C0.896875 3.51801 0 4.41488 0 5.51801V13.518C0 14.6211 0.896875 15.518 2 15.518H14C15.1031 15.518 16 14.6211 16 13.518V5.51801C16 4.41488 15.1031 3.51801 14 3.51801H12V2.26801C12 1.30238 11.2156 0.518005 10.25 0.518005H5.75C4.78438 0.518005 4 1.30238 4 2.26801Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }